import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './FinalizeRegistration.scss';

const RegistrationVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="finalize-registration-page page-container">
      <div className="page-title">
        <h1>LeapFrog Lab Registration</h1>
      </div>

      <div className="child-form form-group">
        <h2 className="page-subtitle">Your registration is almost complete</h2>
        <p>
          You should receive an email* that will ask you to confirm your
          registration for security purposes. Please follow the instructions in
          this email within the next 72 hours to become an active member for
          LeapFrog Lab testing.
        </p>
        <p>Thank you for taking the time to complete this process!</p>
        <p>
          * If you do not receive the confirmation email within a few minutes of
          signing up, please check your Spam / Junk mail folder. If you still do
          not receive the confirmation email, please send an email to
          leapfroglab@leapfrog.com and we will do our best to answer your
          request as soon as possible.
        </p>
      </div>
    </div>
  );
};

export default RegistrationVerification;
